import script from "./RoutesSidebarDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RoutesSidebarDetails.vue?vue&type=script&setup=true&lang=js"

import "./RoutesSidebarDetails.vue?vue&type=style&index=0&id=a42c1668&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a42c1668"]])

export default __exports__